// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ContentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ContentQuery = { paginateContent?: { total?: unknown, items?: Array<{ id?: string, title?: string, content?: string, published: boolean, publishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, uniqueImpressions?: unknown, pageTitle?: string, image?: { url?: string, reference?: string, provider?: string }, link?: { url?: string, type?: Types.ContentLinkType, view?: string, viewType?: string }, pageImage?: { url?: string, reference?: string, provider?: string }, pageContent?: { json?: string, html?: string } }> } };

export type ContentDetailsFragment = { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, uniqueImpressions?: unknown, pageTitle?: string, image?: { url?: string, reference?: string, provider?: string }, link?: { url?: string, type?: Types.ContentLinkType, view?: string, viewType?: string }, pageImage?: { url?: string, reference?: string, provider?: string }, pageContent?: { json?: string, html?: string } };

export type UpsertContentMutationVariables = Types.Exact<{
  content: Types.ContentInput;
}>;


export type UpsertContentMutation = { upsertContent?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, uniqueImpressions?: unknown, pageTitle?: string, image?: { url?: string, reference?: string, provider?: string }, link?: { url?: string, type?: Types.ContentLinkType, view?: string, viewType?: string }, pageImage?: { url?: string, reference?: string, provider?: string }, pageContent?: { json?: string, html?: string } } };

export type SegmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SegmentsQuery = { segments?: Array<{ value?: string, label?: string }> };

export type CountUsersWithSegmentsQueryVariables = Types.Exact<{
  segmentIn: Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>;
  segmentNotIn: Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CountUsersWithSegmentsQuery = { countUsersWithSegments?: { total: unknown, inSegments: unknown } };

export type SingleInnholdQueryVariables = Types.Exact<{
  contentId: Types.Scalars['String']['input'];
}>;


export type SingleInnholdQuery = { singleContent?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, uniqueImpressions?: unknown, pageTitle?: string, image?: { url?: string, reference?: string, provider?: string }, link?: { url?: string, type?: Types.ContentLinkType, view?: string, viewType?: string }, pageImage?: { url?: string, reference?: string, provider?: string }, pageContent?: { json?: string, html?: string } } };

export type DeleteContentMutationVariables = Types.Exact<{
  contentId: Types.Scalars['String']['input'];
}>;


export type DeleteContentMutation = { deleteContent?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, uniqueImpressions?: unknown, pageTitle?: string, image?: { url?: string, reference?: string, provider?: string }, link?: { url?: string, type?: Types.ContentLinkType, view?: string, viewType?: string }, pageImage?: { url?: string, reference?: string, provider?: string }, pageContent?: { json?: string, html?: string } } };

export const ContentDetailsFragmentDoc = gql`
    fragment ContentDetails on Content {
  id
  title
  content
  published
  publishDate
  segmentIn
  segmentNotIn
  uniqueImpressions
  image {
    url
    reference
    provider
  }
  link {
    url
    type
    view
    viewType
  }
  pageTitle
  pageImage {
    url
    reference
    provider
  }
  pageContent {
    json
    html
  }
}
    `;
export const ContentDocument = gql`
    query Content {
  paginateContent {
    total
    items {
      ...ContentDetails
    }
  }
}
    ${ContentDetailsFragmentDoc}`;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContentQuery, ContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
// @ts-ignore
export function useContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContentQuery, ContentQueryVariables>;
export function useContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContentQuery | undefined, ContentQueryVariables>;
export function useContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentSuspenseQueryHookResult = ReturnType<typeof useContentSuspenseQuery>;
export type ContentQueryResult = ApolloReactCommon.QueryResult<ContentQuery, ContentQueryVariables>;
export const UpsertContentDocument = gql`
    mutation UpsertContent($content: ContentInput!) {
  upsertContent(content: $content) {
    ...ContentDetails
  }
}
    ${ContentDetailsFragmentDoc}`;
export type UpsertContentMutationFn = ApolloReactCommon.MutationFunction<UpsertContentMutation, UpsertContentMutationVariables>;

/**
 * __useUpsertContentMutation__
 *
 * To run a mutation, you first call `useUpsertContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContentMutation, { data, loading, error }] = useUpsertContentMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpsertContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContentMutation, UpsertContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContentMutation, UpsertContentMutationVariables>(UpsertContentDocument, options);
      }
export type UpsertContentMutationHookResult = ReturnType<typeof useUpsertContentMutation>;
export type UpsertContentMutationResult = ApolloReactCommon.MutationResult<UpsertContentMutation>;
export type UpsertContentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContentMutation, UpsertContentMutationVariables>;
export const SegmentsDocument = gql`
    query Segments {
  segments {
    value
    label
  }
}
    `;

/**
 * __useSegmentsQuery__
 *
 * To run a query within a React component, call `useSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
      }
export function useSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
        }
// @ts-ignore
export function useSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SegmentsQuery, SegmentsQueryVariables>;
export function useSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SegmentsQuery | undefined, SegmentsQueryVariables>;
export function useSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
        }
export type SegmentsQueryHookResult = ReturnType<typeof useSegmentsQuery>;
export type SegmentsLazyQueryHookResult = ReturnType<typeof useSegmentsLazyQuery>;
export type SegmentsSuspenseQueryHookResult = ReturnType<typeof useSegmentsSuspenseQuery>;
export type SegmentsQueryResult = ApolloReactCommon.QueryResult<SegmentsQuery, SegmentsQueryVariables>;
export const CountUsersWithSegmentsDocument = gql`
    query CountUsersWithSegments($segmentIn: [String]!, $segmentNotIn: [String]!) {
  countUsersWithSegments(segmentIn: $segmentIn, segmentNotIn: $segmentNotIn) {
    total
    inSegments
  }
}
    `;

/**
 * __useCountUsersWithSegmentsQuery__
 *
 * To run a query within a React component, call `useCountUsersWithSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersWithSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersWithSegmentsQuery({
 *   variables: {
 *      segmentIn: // value for 'segmentIn'
 *      segmentNotIn: // value for 'segmentNotIn'
 *   },
 * });
 */
export function useCountUsersWithSegmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables> & ({ variables: CountUsersWithSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>(CountUsersWithSegmentsDocument, options);
      }
export function useCountUsersWithSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>(CountUsersWithSegmentsDocument, options);
        }
// @ts-ignore
export function useCountUsersWithSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>;
export function useCountUsersWithSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountUsersWithSegmentsQuery | undefined, CountUsersWithSegmentsQueryVariables>;
export function useCountUsersWithSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>(CountUsersWithSegmentsDocument, options);
        }
export type CountUsersWithSegmentsQueryHookResult = ReturnType<typeof useCountUsersWithSegmentsQuery>;
export type CountUsersWithSegmentsLazyQueryHookResult = ReturnType<typeof useCountUsersWithSegmentsLazyQuery>;
export type CountUsersWithSegmentsSuspenseQueryHookResult = ReturnType<typeof useCountUsersWithSegmentsSuspenseQuery>;
export type CountUsersWithSegmentsQueryResult = ApolloReactCommon.QueryResult<CountUsersWithSegmentsQuery, CountUsersWithSegmentsQueryVariables>;
export const SingleInnholdDocument = gql`
    query singleInnhold($contentId: String!) {
  singleContent(contentId: $contentId) {
    ...ContentDetails
  }
}
    ${ContentDetailsFragmentDoc}`;

/**
 * __useSingleInnholdQuery__
 *
 * To run a query within a React component, call `useSingleInnholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleInnholdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleInnholdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useSingleInnholdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleInnholdQuery, SingleInnholdQueryVariables> & ({ variables: SingleInnholdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleInnholdQuery, SingleInnholdQueryVariables>(SingleInnholdDocument, options);
      }
export function useSingleInnholdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleInnholdQuery, SingleInnholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleInnholdQuery, SingleInnholdQueryVariables>(SingleInnholdDocument, options);
        }
// @ts-ignore
export function useSingleInnholdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleInnholdQuery, SingleInnholdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleInnholdQuery, SingleInnholdQueryVariables>;
export function useSingleInnholdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleInnholdQuery, SingleInnholdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleInnholdQuery | undefined, SingleInnholdQueryVariables>;
export function useSingleInnholdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleInnholdQuery, SingleInnholdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleInnholdQuery, SingleInnholdQueryVariables>(SingleInnholdDocument, options);
        }
export type SingleInnholdQueryHookResult = ReturnType<typeof useSingleInnholdQuery>;
export type SingleInnholdLazyQueryHookResult = ReturnType<typeof useSingleInnholdLazyQuery>;
export type SingleInnholdSuspenseQueryHookResult = ReturnType<typeof useSingleInnholdSuspenseQuery>;
export type SingleInnholdQueryResult = ApolloReactCommon.QueryResult<SingleInnholdQuery, SingleInnholdQueryVariables>;
export const DeleteContentDocument = gql`
    mutation deleteContent($contentId: String!) {
  deleteContent(contentId: $contentId) {
    ...ContentDetails
  }
}
    ${ContentDetailsFragmentDoc}`;
export type DeleteContentMutationFn = ApolloReactCommon.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = ApolloReactCommon.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;